export function merchantPaymentError(error: unknown, tr: (key: string) => string): string {
  const value = error as { message?: string; code?: string; bodyText?: string } | null;
  let key = value?.code ?? value?.message;
  if (value?.bodyText) {
    try { const body = JSON.parse(value.bodyText) as { errorKey?: string }; key = body.errorKey ?? key; } catch { /* Non-JSON responses use the common error. */ }
  }
  return tr(key?.startsWith("merchantPayments.") ? key : "merchantPayments.error");
}
